import intlTelInput from 'intl-tel-input/intlTelInputWithUtils';

export function phoneNumberFormatter({ inputId, phoneAttributeName }) {
  const input = document.querySelector(inputId);

  // Plugin initialization
  const iti = intlTelInput(input, {
    countryOrder: ['fr', 'ch'],
    formatOnDisplay: true,
    hiddenInput: () => ({ phone: phoneAttributeName }),
    initialCountry: 'fr',
    nationalMode: false,
    separateDialCode: true,
  });

  // On focus loss -> validate
  input.addEventListener('blur', () => {
    if (!input.value.trim()) return;

    input.classList.toggle('is-invalid', !iti.isValidNumberPrecise());
  });
}
